import { RepositoryFactory } from '../../repositoryFactory';
import router from '../../routes';

const AuthRepository = RepositoryFactory.get('auth');

export default {
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: {},
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    user: (state) => state.user,
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading';
    },
    auth_success(state, { token, user }) {
      const locale = state.user.locale ?? 'th';
      state.status = 'success';
      state.token = token;
      state.user = { ...user, ...{ locale } };
    },
    auth_update(state, { user }) {
      const {
        // eslint-disable-next-line camelcase
        id, first_name, last_name, full_name, tel, tel_confirmed,
      } = user;
      state.user = {
        ...user,
        ...{
          id, first_name, last_name, full_name, tel, tel_confirmed,
        },
        ...{
          locale: state.user.locale || 'th',
        },
      };
    },
    auth_error(state) {
      state.status = 'error';
    },
    logout(state) {
      state.status = '';
      state.token = '';
      state.user = {};
    },
    set_locale(state, payload) {
      state.user = { ...state.user, locale: payload };
    },
  },
  actions: {
    login({ commit }, payload) {
      commit('auth_request');
      return new Promise((resolve, reject) => {
        AuthRepository.login(payload).then((resp) => {
          const { token, user } = resp.data;
          localStorage.setItem('token', token);
          commit('auth_success', { token, user });
          // Redirect the user to the page he first tried to visit or to the home view
          router.push(router.history.current.query.redirect || '/');
          resolve(user);
        }).catch((err) => {
          commit('auth_error');
          localStorage.removeItem('token');
          reject(err);
        });
      });
    },
    loginWithSocial({ commit }, payload) {
      commit('auth_request');
      return new Promise((resolve, reject) => {
        AuthRepository.loginWithSocial('facebook', payload).then((resp) => {
          const { token, user } = resp.data;
          localStorage.setItem('token', token);
          commit('auth_success', { token, user });
          // Redirect the user to the page he first tried to visit or to the home view
          router.push(router.history.current.query.redirect || '/');
          resolve(user);
        }).catch((err) => {
          commit('auth_error');
          localStorage.removeItem('token');
          reject(err);
        });
      });
    },
    register({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        AuthRepository.register(payload).then((resp) => {
          const { token, user } = resp.data;
          localStorage.setItem('token', token);
          commit('auth_success', { token, user });
          // Redirect the user to the page he first tried to visit or to the home view
          router.push(router.history.current.query.redirect || '/account/profile');
          // window.location = '/';
          resolve(user);
        }).catch((err) => {
          commit('auth_error', err);
          localStorage.removeItem('token');
          reject(err);
        });
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('logout');
        localStorage.removeItem('token');
        router.push('/');
        resolve();
      });
    },
    reset_password({ commit }, payload) {
      commit('auth_request');
      return new Promise((resolve, reject) => {
        AuthRepository.reset_password(payload).then(() => {
          resolve();
        }).catch((err) => {
          commit('auth_error', err);
          reject(err);
        });
      });
    },
    update_password({ commit }, payload) {
      commit('auth_request');
      return new Promise((resolve, reject) => {
        AuthRepository.update_password(payload).then((resp) => {
          const { token, user } = resp.data;
          localStorage.setItem('token', token);
          commit('auth_success', { token, user });
          // Redirect the user to the page he first tried to visit or to the home view
          router.push(router.history.current.query.redirect || '/');
          resolve();
        }).catch((err) => {
          commit('auth_error', err);
          reject(err);
        });
      });
    },
    setLocale({ commit }, payload) {
      return new Promise((resolve) => {
        commit('set_locale', payload);
        resolve();
      });
    },
  },
};
